import utils from './utils'
import http from './http'
import baseURL from './baseURL/baseURL'
import { getCleanShareUrl } from './webIdentity'
let wx = require('weixin-js-sdk')

let weixin = {
    getAppID() {
        return process.env.VUE_APP_WX_APPID
    },
    async config(shareInfo) {
        let data = await http.postParams(baseURL.weixin.getSignInfo(), {url: utils.getWeiXinUrl() || window.location.href.split('#')[0]})
        wx.config({
            debug: false,
            appId: process.env.VUE_APP_WX_APPID, // 必填，公众号的唯一标识 正式appid
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串  
            signature: data.signature,// 必填，签名
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo', 'onMenuShareQZone', 'openLocation', 'getLocation'] // 必填，需要使用的JS接口列表
        })
        wx.ready(() => {
            if (typeof(shareInfo) === "object") {
                let tempParam = {
                    title: shareInfo.shareTitle,
                    desc: shareInfo.shareContent,
                    link: getCleanShareUrl(),
                    imgUrl: shareInfo.sharePosters,
                    success() {},
                    cancel() {}
                }
                wx.updateAppMessageShareData(tempParam)
                wx.updateTimelineShareData(tempParam)
                wx.onMenuShareWeibo(tempParam)
                wx.onMenuShareQZone(tempParam)
            }
        })
        wx.error(() => {})
    },
    openLocation(latitude, longitude,name, desc) {
        wx.openLocation({
            latitude: latitude, // 纬度，浮点数，范围为90 ~ -90
            longitude: longitude, // 经度，浮点数，范围为180 ~ -180。
            name: name, // 位置名
            address: desc, // 地址详情说明
            scale: 28, // 地图缩放级别,整形值,范围从1~28。默认为最大
            infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
        })
    }
}

export default weixin
